const API_URL = (process.env.REACT_APP_API_URL || "").trim() || "http://localhost:3001";

export class HttpError extends Error {
  status: number;
  constructor(status: number, message = `HTTP ${status}`) {
    super(message);
    this.status = status;
  }
}

type ParseFn<T> = (raw: unknown) => T;

export async function get<T>(
  path: string,
  parse: ParseFn<T>,
  opts: { signal?: AbortSignal; headers?: Record<string, string> } = {}
): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method: "GET",
    signal: opts.signal,
    headers: { Accept: "application/json", ...(opts.headers || {}) },
  });
  if (!res.ok) throw new HttpError(res.status);
  const json = await res.json();
  return parse(json);
}

export function qs(params: Record<string, string | null | undefined>) {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v != null && v !== "") sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : "";
}